// extracted by mini-css-extract-plugin
export default {"animation":"animation__SCSMe","fadeInAnimation":"fadeInAnimation__3sUMh","heading":"heading__SRU52","textArea":"textArea__XsTKj","submitButton":"submitButton__tGuEB"};